import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Spin,
  Upload,
  Alert,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import useSuccessErrorModal from "../../hooks/successErrorModal/useSuccessErrorModal";
import Endpoints from "../../api/endpoints";
import EndpointFunctions from "../../utils/Functions/endpointFunctions";
import PageRoutes from "../../utils/routes";

const CreateCardBackgroundPreset = () => {
  const [form] = Form.useForm();
  const [imageFileList, setImageFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const { showModal, closeModal, ModalComponent } = useSuccessErrorModal();

  const onFinish = async (values) => {
    if (!imageFileList[0]?.originFileObj) {
      showModal("Hata", "Lütfen bir görsel yükleyin.", () => closeModal());
      return;
    }

    setIsLoading(true);

    const requestBody = {
      name: values.name,
      displayOrder: values.displayOrder ?? 0,
    };

    const formData = new FormData();
    formData.append(
      "request",
      new Blob([JSON.stringify(requestBody)], { type: "application/json" })
    );
    formData.append("file", imageFileList[0].originFileObj);

    const result = await EndpointFunctions.postData({
      endpointURL: Endpoints.createCardBackgroundPreset,
      formData: formData,
      axiosPrivate: axiosPrivate,
      isMultiPart: true,
    });

    setIsLoading(false);

    if (result.success) {
      showModal("Başarılı", "Preset oluşturuldu.", () => {
        closeModal();
        navigate(PageRoutes.cardBackgroundPresets);
      });
    } else {
      showModal(result.errorTitle, result.errorMessage, () => closeModal());
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <Spin spinning={isLoading}>
        <Card title="Yeni Kart Arka Plan Preset'i">
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 16 }}
            message="Görsel kuralları"
            description={
              <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
                <li>
                  Oran <b>350:502</b> (portrait, ±%2 tolerans). Önerilen tam
                  boyut: <b>1200×1722 px</b>.
                </li>
                <li>Min yükseklik 800 piksel, max dosya boyutu 5MB.</li>
                <li>JPEG veya PNG.</li>
                <li>
                  Backend görseli otomatik 1200×1722 (full) ve 400×574 (thumb)
                  JPEG @85'e dönüştürür.
                </li>
              </ul>
            }
          />
          <Form form={form} layout="vertical" onFinish={onFinish}>
            <Row gutter={[16, 0]}>
              <Col span={16}>
                <Form.Item
                  name="name"
                  label="İsim (admin için iç isim)"
                  rules={[
                    { required: true, message: "İsim zorunludur" },
                    { max: 100, message: "Max 100 karakter" },
                  ]}>
                  <Input placeholder="Örn: Kahve Çekirdeği Doku" />
                </Form.Item>
              </Col>

              <Col span={8}>
                <Form.Item
                  name="displayOrder"
                  label="Sıra"
                  initialValue={0}
                  tooltip="Küçükten büyüğe sıralanır. Eşitlik durumunda id'ye göre.">
                  <InputNumber min={0} max={32767} style={{ width: "100%" }} />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Görsel"
                  required
                  tooltip="350:502 oranında, min 800px yükseklik, max 5MB">
                  <Upload
                    beforeUpload={() => false}
                    listType="picture"
                    maxCount={1}
                    onChange={(e) => setImageFileList(e.fileList)}
                    accept="image/png, image/jpeg"
                    fileList={imageFileList}>
                    <Button icon={<UploadOutlined />}>Görsel Seç</Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isLoading}>
                Oluştur
              </Button>
              <Button
                style={{ marginLeft: 8 }}
                onClick={() => navigate(PageRoutes.cardBackgroundPresets)}>
                Vazgeç
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
      <ModalComponent />
    </div>
  );
};

export default CreateCardBackgroundPreset;
